import type {
    ActivationAlertsContractGroupAdType,
    ActivationAlertsContractSocialAdPlatform,
} from "@similarweb/pro-api-client";

import { useAlertsParams } from "../../hooks/useAlertsParams";
import { useEffectiveSelectedCompetitors } from "../filters/competitors/useEffectiveSelectedCompetitors";
import type { ValueMap } from "../filters/types";

import { useAdsAlertsFilterStore } from "./filters/useAdsAlertsFilterStore";
import type { AdsType } from "./types";
import { ALL_SOCIAL_SUBCATEGORIES, type SocialSubcategoryId } from "./utils/getPlatformName";

const getSelectedPlatforms = (
    selectedSocialSubcategories: Set<SocialSubcategoryId>,
): ActivationAlertsContractSocialAdPlatform[] | undefined => {
    if (selectedSocialSubcategories.size === 0 || selectedSocialSubcategories.size === ALL_SOCIAL_SUBCATEGORIES.length) {
        return undefined;
    }

    return [...selectedSocialSubcategories];
};

const getSelectedAdTypes = (
    selectedAdsTypes: ValueMap<AdsType>,
    selectedSocialSubcategories: Set<SocialSubcategoryId>,
): ActivationAlertsContractGroupAdType[] | undefined => {
    const adTypes: ActivationAlertsContractGroupAdType[] = [...selectedAdsTypes.keys()];

    if (selectedSocialSubcategories.size > 0) {
        adTypes.push("Social");
    }

    if (adTypes.length === 0) {
        return undefined;
    }

    return adTypes;
};

export const useAdsAlertsQueryParams = () => {
    const { activationId } = useAlertsParams();
    const { selectedCompetitorIds } = useEffectiveSelectedCompetitors({ primaryCompetitorsOnly: true });
    const isDefaultAdsTypesSelected = useAdsAlertsFilterStore((state) => state.isDefaultAdsTypesSelected);
    const selectedAdsTypes = useAdsAlertsFilterStore((state) => state.selectedAdsTypes);
    const selectedSocialSubcategories = useAdsAlertsFilterStore((state) => state.selectedSocialSubcategories);

    return {
        activationId,
        competitors: selectedCompetitorIds,
        ...(!isDefaultAdsTypesSelected && {
            adTypes: getSelectedAdTypes(selectedAdsTypes, selectedSocialSubcategories),
            platforms: getSelectedPlatforms(selectedSocialSubcategories),
        }),
    };
};
